export enum UserDataChangesEndpoint {
  Base = '/history',
  Users = '/users',
  PersonalData = '/personal-data',
  Deleted = '/deleted',
}
